import { createApp } from 'vue'
import { createPinia } from 'pinia'
import VueApexCharts from 'vue3-apexcharts'

import App from './App.vue'
import { router } from './router'
import { installPrimeVue } from './plugins/primevue'
import { setUnauthorizedHandler } from './api/client'
import { useAuthStore } from './stores/auth'

import './assets/styles/main.css'

/**
 * Red de seguridad para la pestaña que ya estaba abierta cuando se desplegó.
 *
 * Los archivos del bundle llevan hash en el nombre, así que un despliegue los
 * reemplaza por otros. Una pestaña con el `index.html` anterior sigue pidiendo
 * los de antes y, al navegar, el import en diferido falla: pantalla en blanco
 * sin nada que explique por qué. Vite avisa de eso con `vite:preloadError`, y
 * la única salida es recargar para tomar el index nuevo.
 *
 * La bandera en sessionStorage evita el bucle: si tras recargar vuelve a
 * fallar, el problema no es el despliegue y recargar en redondo solo lo
 * esconde.
 */
const RELOAD_FLAG = 'vetalia.reloaded-for-stale-bundle'

window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault()
  if (sessionStorage.getItem(RELOAD_FLAG)) return
  sessionStorage.setItem(RELOAD_FLAG, '1')
  window.location.reload()
})

window.addEventListener('load', () => sessionStorage.removeItem(RELOAD_FLAG))

const app = createApp(App)

app.use(createPinia())
app.use(router)
installPrimeVue(app)
app.use(VueApexCharts)

// Un 401 en cualquier llamada significa que la cookie caducó del lado del
// servidor. Se limpia la sesión local y el guard del router hace el resto:
// sin esto, la pantalla se quedaría vacía sin decir por qué.
setUnauthorizedHandler(() => {
  useAuthStore().clear()
  if (router.currentRoute.value.name !== 'login') {
    router.push({ name: 'login', query: { redirect: router.currentRoute.value.fullPath } })
  }
})

app.mount('#app')
